/** @griffel:css-start [d] null **/
.f1ewtqcl{box-sizing:border-box;}
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f1noh358{row-gap:var(--spacingVerticalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f16epzkf{padding-block:var(--spacingVerticalL);}
.fjshy37{padding-inline:var(--spacingHorizontalL);}
.fgdu4nw{padding-inline:0;}
.fnllxr2{padding-block:var(--spacingVerticalM);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fni485r{flex-wrap:wrap;}
.f122n59{align-items:center;}
.f1869bpl{justify-content:space-between;}
.f1xcgk68{column-gap:var(--spacingHorizontalM);}
.f1wn3y0l{row-gap:var(--spacingVerticalS);}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f8ntp42{margin-block:0;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fjksvth{overflow-wrap:anywhere;}
/** @griffel:css-end **/